<nb-select id="normType"
           fullWidth
           [(selected)]="value"
           [disabled]="isDisabled">
  <nb-option [value]="NormTypes.Norm1300">B1300</nb-option>
  <nb-option [value]="NormTypes.Norm1301">B1301</nb-option>
</nb-select>
